import {
  SET_AUTO_FILL_DESCRIPTION,
  SET_FORM_ROLE_TYPE,
  SET_GENERATED_PROJECT,
  SET_LOADING,
  SET_LOCATION_LIST,
  SET_SELECTED_ROLES,
} from "../../actions/project/types";

const INITIAL_STATE = {
  loading: false,
  locationList: [],
  selectedRoleList: [],
  formRoleType: "add",
  autofillDescription: "",
  generatedProject: {},
};

const ProjectReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case SET_LOCATION_LIST: {
      return {
        ...state,
        locationList: action.payload,
      };
    }
    case SET_SELECTED_ROLES: {
      return {
        ...state,
        selectedRoleList: action.payload,
      };
    }
    case SET_FORM_ROLE_TYPE: {
      return {
        ...state,
        formRoleType: action.payload,
      };
    }
    case SET_AUTO_FILL_DESCRIPTION:
      return {
        ...state,
        autofillDescription: action.payload,
      };
    case SET_GENERATED_PROJECT: {
      return {
        ...state,
        generatedProject: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default ProjectReducer;
